import { useEffect, useRef } from 'react';
import { startCanvas2D } from '../utils/canvas2d';
import { DEFAULT_COLORS } from '../utils/constants';
import { startWebGL } from '../utils/webgl';
import { supportsWebGL2Float } from '../utils/webglCore';

export const useMeshGradient = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const mouseRef = useRef({ x: 0.5, y: 0.2, targetX: 0.5, targetY: 0.2 });
  const scrollRef = useRef({ current: 0, target: 0 });
  const currentPaletteRef = useRef(DEFAULT_COLORS.map((color) => [...color]));

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    if (supportsWebGL2Float()) {
      const webglStop = startWebGL(
        canvas,
        mouseRef,
        scrollRef,
        currentPaletteRef,
        animationRef
      );
      if (webglStop) return webglStop;
    }

    return startCanvas2D(
      canvas,
      mouseRef,
      scrollRef,
      currentPaletteRef,
      animationRef
    );
  }, []);

  return canvasRef;
};
